import React, { Component } from "react";
import {
  Input,
  Select,
  DatePicker,
  Space,
  Upload,
  message,
  Form,
  Cascader,
  version,
  ConfigProvider,
} from "antd";
import moment from "moment";
import { useCallback } from "react";
import "antd/dist/antd.css";
import provinces from "./fieldOptions/provinces.json";
import cities from "./fieldOptions/cities.json";
import areas from "./fieldOptions/areas.json";
import locale from "antd/es/date-picker/locale/zh_CN";
// import zh_CN from 'antd/lib/locale-provider/zh_CN';
// import 'moment/locale/zh-cn';

const { RangePicker } = DatePicker;
const { TextArea } = Input;
const FormItem = Form.Item;

areas.forEach((area) => {
  const matchCity = cities.filter((city) => city.code === area.cityCode)[0];
  if (matchCity) {
    matchCity.children = matchCity.children || [];
    matchCity.children.push({
      label: area.name,
      value: area.code,
    });
  }
});

cities.forEach((city) => {
  const matchProvince = provinces.filter(
    (province) => province.code === city.provinceCode
  )[0];
  if (matchProvince) {
    matchProvince.children = matchProvince.children || [];
    matchProvince.children.push({
      label: city.name,
      value: city.code,
      children: city.children,
    });
  }
});

const options1 = provinces.map((province) => ({
  label: province.name,
  value: province.code,
  children: province.children,
}));

let areaObj = {};
function eachAreaList(list) {
  list.forEach((item) => {
    areaObj[item.value] = item.label;
    item.children && item.children.length && eachAreaList(item.children);
  });
}
eachAreaList(options1);
// console.log('------options1-------',areaObj);

export const WrapContainer = ({ title, addEditBtn, children }) => {
  return (
    <div className="wrap_container">
      <div className="wrap_header">
        <div className="header_title">{title}</div>
        {addEditBtn(title)}
      </div>
      <div className="wrap_content">{children}</div>
    </div>
  );
};

export const EditForm = ({ children }) => {
  return (
    <div className="edit_form_container">
      <div className="edit_form_content">{children}</div>
    </div>
  );
};

export const EchoForm = ({
  dataList,
  typeIndex = "",
  children,
  otherComponent = () => {},
  onEditInfo,
  onDelInfo,
  showEditBtn = true,
  showDelBtn = true,
}) => {
  const type = typeIndex.split("-")[0];
  return (
    <div className="echo_form_content">
      {children({ dataList, type })}
      <div className="edit_del">
        {showEditBtn && (
          <div
            className="edit_info"
            onClick={() => onEditInfo(typeIndex)}
          ></div>
        )}
        {showDelBtn && (
          <div className="del_info" onClick={() => onDelInfo(typeIndex)}></div>
        )}
      </div>
      {otherComponent()}
    </div>
  );
};

export const EchoFormItem = ({ dataList, type }) => {
  // console.log('dataList, type',dataList, type,options);

  switch (type) {
    case "2":
      return (
        <div className="form_echo2">
          {dataList &&
            dataList.map(({ label, value, options }) => {
              console.log("options", options, label, value);
              if (label == "学历") {
                return options.map((childrenItem) => {
                  if (childrenItem.value == value) {
                    return (
                      <span className="form_item_echo" key={label}>
                        {childrenItem.label || ""}
                      </span>
                    );
                  }
                  // childrenItem.value ==value ? childrenItem.label :value ||''
                });
              } else {
                return (
                  <span className="form_item_echo" key={label}>
                    {value || ""}
                  </span>
                );
              }
            })}
        </div>
      );
    case "3":
      return (
        <div className="work_experience_item">
          <div className="form_echo2">
            {dataList &&
              dataList.map(({ label, name, value }) => {
                if (name != "jobContent") {
                  return (
                    <>
                      <span className="form_label_echo" key={label}>
                        {label}：
                      </span>
                      <span className="form_item_echo" key={label}>
                        {value || ""}
                      </span>
                    </>
                  );
                }
              })}
          </div>
          <div className="work_describe">
            {dataList &&
              dataList.map(({ label, name, value }) => {
                if (name == "jobContent") {
                  return (
                    <>
                      <span className="form_label_echo" key={label}>
                        {label}：
                      </span>
                      <span className="work_describe_echo" key={name}>
                        {value}
                      </span>
                    </>
                  );
                }
              })}
          </div>
        </div>
      );
    case "4":
      return (
        <div className="evaluation_items">
          {dataList &&
            dataList.map(({ label, name, value }) => {
              return (
                <div className="form_echo4" key={name}>
                  <span className="form_label_echo">{label}:</span>
                  <span className="form_item_echo">{value || ""}</span>
                </div>
              );
            })}
        </div>
      );
    default:
      return (
        <ul className="base_info_list">
          {dataList &&
            dataList.map(({ label, value }) => {
              return (
                <li className="base_info_item" key={label}>
                  <div className="form_echo">
                    <span className="form_label_echo">{label}:</span>
                    <span className="form_item_echo">{value || ""}</span>
                  </div>
                </li>
              );
            })}
        </ul>
      );
  }
};

export const RenderForm = ({
  dataList,
  children,
  onChange,
  handleCancel,
  handleSave,
  formIndex = "",
}) => {
  return (
    <>
      <ul className="base_info_list">
        {dataList.length &&
          dataList.map((item, itemIndex) => {
            return (
              <li
                className={[
                  "base_info_item",
                  item.name == "jobContent" ? "job_content" : "",
                ].join(" ")}
                key={itemIndex}
              >
                {children({ ...item, formIndex, onChange })}
              </li>
            );
          })}
      </ul>
      <div className="edit_btns">
        <div className="cancel_btn" onClick={handleCancel}>
          取消
        </div>
        <div className="save_btn" onClick={handleSave}>
          保存
        </div>
      </div>
    </>
  );
};

export const RenderFormItem = ({
  type,
  label,
  name,
  value,
  placeholder,
  options,
  rules = [],
  formIndex,
  onChange,
}) => {
  let rule = {};
  rules.length &&
    rules.forEach((ele) => {
      rule[ele.trigger] = ele;
    });
  let v = value;
  const handleChange = useCallback((e, nameIndex) => {
    // console.log('------handleChange------',e);
    if (typeof e == "string" || Array.isArray(e)) {
      if (name == "origin") {
        //将地区索引转为字符串
        e.forEach((item, index, array) => (array[index] = areaObj[item]));
        v = e.join("-");
      } else {
        v = e; //如果e的值是字符串或者数组
      }
    } else {
      e.persist(); //用于保留react合成事件中的属性值
      v = e.target.value;
    }
    console.log("------handleChange------", v);
    onChange(v, nameIndex);
  }, []);
  const handleBlur = useCallback(() => {
    if (rule.blur && rule.blur.required && !v) {
      console.log(rule.blur.message + label);
    }
  }, [label, rule.blur, v]);

  switch (type) {
    case "area":
      return (
        <>
          <span className="form_label">{label}</span>
          <Cascader
            options={options1}
            showSearch
            fieldNames={`${name}-${formIndex}`}
            value={value}
            onChange={(e) => {
              handleChange(e, `${name}-${formIndex}`);
            }}
            placeholder="请选择地址"
            style={{ width: 400 }}
          />
        </>
      );
    case "select":
      return (
        <>
          <span className="form_label">{label}</span>
          <Select
            name={`${name}-${formIndex}`}
            value={value}
            options={options}
            placeholder="请选择"
            onChange={(e) => {
              handleChange(e, `${name}-${formIndex}`);
            }}
          >
            {options.map((el) => {
              return (
                <Select.Option key={el.label} value={el.value}>
                  {el.label}
                </Select.Option>
              );
            })}
          </Select>
        </>
      );
    case "date":
      return (
        <>
          <span className="form_label">{label}</span>
          <Space direction="vertical">
            <DatePicker
              locale={locale}
              style={{ border: "" }}
              name={`${name}-${formIndex}`}
              value={value ? moment(value) : ""}
              onChange={(date, dateString) => {
                handleChange(dateString, `${name}-${formIndex}`);
              }}
              placeholder="请选择日期"
            />
          </Space>
        </>
      );
    case "start_stop_time":
      return (
        <>
          <span className="form_label">{label}</span>
          <Space direction="vertical">
            <RangePicker
              locale={locale}
              style={{ border: "" }}
              name={`${name}-${formIndex}`}
              value={value ? [moment(value[0]), moment(value[1])] : ""}
              onChange={(date, dateString) => {
                handleChange(dateString, `${name}-${formIndex}`);
              }}
              placeholder=""
            />
          </Space>
        </>
      );
    default:
      return (
        <>
          <span className="form_label">{label}</span>
          {name === "jobContent" ? (
            <TextArea
              type="text"
              name={`${name}-${formIndex}`}
              value={value}
              onChange={(e) => {
                handleChange(e, `${name}-${formIndex}`);
              }}
              placeholder={placeholder}
            />
          ) : (
            <Input
              type="text"
              rows={4}
              name={`${name}-${formIndex}`}
              value={value}
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e, `${name}-${formIndex}`);
              }}
              placeholder={placeholder}
            />
          )}
        </>
      );
  }
};
